/**
 * The Router component exists to handle the switching between the ReactRouter Browser Router and Static Router based on the environment being eithe a server side rendering environment or browser based.
 *
 * @module views/Navigation/Router
 */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom/server';

import PropTypes from 'prop-types';

import { isServer } from '@ulta/core/utils/device_detection/device_detection';

/**
 * Represents a Router component
 *
 * @method
 * @param { Object } props - React properties passed from composition
 * @returns Router
 */
export const Router = function( props ){
  const { children, href } = props;
  const RouterComponent = isServer() ? StaticRouter : BrowserRouter;
  return (
    <RouterComponent
      location={ href }
    >
      { children }
    </RouterComponent>
  );
};

/**
 * property type definitions
 * @type object
 * @property { Boolean } isServer - server side rendering flag for setting a path for rout rendering
 */
export const propTypes = {
  isServer: PropTypes.bool
};

Router.propTypes = propTypes;

export default Router;
